import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
// const URL = 'http://192.168.250.135:8080';

const URL = process.env.REACT_APP_LIVE_LINK_SOCKET;
// const URL = 'http://185.201.9.13:5000';
//test
export const socket = io(URL, {
  path: '/socket.io',
  transports: ['websocket'],
  secure: true,
  autoConnect: false
});

export function connect() {
  socket.connect();
}

export function disconnect() {
  socket.disconnect();
}
